import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useVehicleModelService from '../../../app/services/hooks/useVehicleModelService';

interface Props {
    vehicleModelId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const VehicleModelSwitchChange = ({ vehicleModelId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeVehicleModel, fetchingActiveVehicleModel } = useVehicleModelService();

    const active = (value: boolean) => {
        setChecked(value);

        activeVehicleModel(vehicleModelId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={vehicleModelId} callback={active} />;
};

export default VehicleModelSwitchChange;
